/**
 * @generated SignedSource<<b21bc0b7edeffe1b12ae60d5a2385bd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RecapTemplateType = "BANT" | "CUSTOMER_SUCCESS" | "MEDDIC" | "SALES_DISCOVERY" | "SALES_FOLLOW_UP" | "SPICED";
export type SalesforceInstanceType = "NOTE" | "TASK";
export type SalesforceSendNotesAsNoteMutation$variables = {
  includeRecap: boolean;
  noteId: string;
  recapTemplateType?: RecapTemplateType | null;
  salesforceParentIds: ReadonlyArray<string>;
};
export type SalesforceSendNotesAsNoteMutation$data = {
  readonly sendNoteToSalesforce: {
    readonly error: string | null;
    readonly id: string | null;
    readonly noteVersion: number | null;
    readonly salesforce: {
      readonly lastUsedSalesforceInstanceType: SalesforceInstanceType;
    } | null;
    readonly url: string | null;
  } | null;
};
export type SalesforceSendNotesAsNoteMutation = {
  response: SalesforceSendNotesAsNoteMutation$data;
  variables: SalesforceSendNotesAsNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRecap"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recapTemplateType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesforceParentIds"
},
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "includeRecap",
        "variableName": "includeRecap"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      },
      {
        "kind": "Variable",
        "name": "recapTemplateType",
        "variableName": "recapTemplateType"
      },
      {
        "kind": "Variable",
        "name": "salesforceParentIds",
        "variableName": "salesforceParentIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noteVersion",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastUsedSalesforceInstanceType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceSendNotesAsNoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "SendNoteToSalesforcePayload",
        "kind": "LinkedField",
        "name": "sendNoteToSalesforce",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesforceUserNode",
            "kind": "LinkedField",
            "name": "salesforce",
            "plural": false,
            "selections": [
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "SalesforceSendNotesAsNoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "SendNoteToSalesforcePayload",
        "kind": "LinkedField",
        "name": "sendNoteToSalesforce",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesforceUserNode",
            "kind": "LinkedField",
            "name": "salesforce",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75796982c3a31fba12706e65b33bcc9c",
    "id": null,
    "metadata": {},
    "name": "SalesforceSendNotesAsNoteMutation",
    "operationKind": "mutation",
    "text": "mutation SalesforceSendNotesAsNoteMutation(\n  $noteId: String!\n  $salesforceParentIds: [String!]!\n  $includeRecap: Boolean!\n  $recapTemplateType: RecapTemplateType\n) {\n  sendNoteToSalesforce(input: {noteId: $noteId, salesforceParentIds: $salesforceParentIds, includeRecap: $includeRecap, recapTemplateType: $recapTemplateType}) {\n    id\n    url\n    error\n    noteVersion\n    salesforce {\n      lastUsedSalesforceInstanceType\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2c037e5456190416e6e46b823306fe0";

export default node;
